import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { getPortfolioIdFromUrl } from '@utils/getUrlParams';
import api from '@services/api';
import usePaginationParams from '@hooks/usePaginationParams';

import type { CampaignType } from './types';

const useGetList = () => {
  const [campaigns, setCampaigns] = useState<CampaignType[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const getCampaigns = useCallback(async ({ page = 1, limit = 10 }) => {
    setLoading(true);
    try {
      const response = await api.get('/campaign', {
        params: {
          pageIndex: page,
          pageLimit: limit,
          portfolioId: getPortfolioIdFromUrl(),
        },
      });
      setCampaigns(response.data.data);
      setTotalPages(response.data.total);
    } catch {
      toast.error('Erro ao carregar campanhas. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  }, []);

  usePaginationParams({ onParamsChange: getCampaigns });

  return {
    getCampaigns,
    campaigns,
    totalPages,
    loading,
  };
};

export default useGetList;
